require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-how-is-the-world-bank-implementing-stakeholder-engagement.json") })
        }
      }, "path---en-us-project-how-is-the-world-bank-implementing-stakeholder-engagement");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-how-is-the-world-bank-implementing-stakeholder-engagement!./.cache/json/en-us-project-how-is-the-world-bank-implementing-stakeholder-engagement.json
// module id = 524
// module chunks = 231608221292675